module.exports = __webpack_public_path__ + "static/img/nav_bg.d2bf3255.png";